import { AssetQuality } from './assetQuality'
import { BusinessGrowth } from './businessGrowth'
import { CapitalAdequacy } from './capitalAdequacy'
import { EarningQuality } from './earningQuality'
import { Liquidity } from './liquidity'

export const Bank = ({ settingsFS }) => {
  return (
    <>
      <CapitalAdequacy settingsFS={settingsFS} />
      <AssetQuality settingsFS={settingsFS} />
      <EarningQuality settingsFS={settingsFS} />
      <Liquidity settingsFS={settingsFS} />
      <BusinessGrowth settingsFS={settingsFS} />
    </>
  )
}
